import React, { useState } from 'react'
import { FaRegEdit } from 'react-icons/fa'

export const EditIcon: React.FC = (...props) => {
  const [hovered, setHovered] = useState(false)
  return (
    <span
      style={{
        color: hovered ? '#1A202C' : '#A0AEC0',
        transition: 'color 0.15s',
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'text',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
    >
      <FaRegEdit size={18} />
    </span>
  )
}
